// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const mobileNavTriggers = document.querySelectorAll('.js-toggle-nav');

    /**
     * Select all burger elements
     */

    for (const mobileNavTrigger of mobileNavTriggers) {
        mobileNavTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            mobileNavToggle();
        });
    }

    /**
     * Toggle open class
     */

    const mobileNavToggle = () => {
        if (document.querySelector('body').classList.contains('nav-is-open')) {
            document.querySelector('body').classList.remove('nav-is-open');
        } else {
            document.querySelector('body').classList.add('nav-is-open');
        }
    }

});
